import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchQuery } from "../helpers/ApiHelpers";

export enum MutualFundTags {
  MutualFund = "mutual-fund",
}

export enum CommonApiTypes {
  Agreement = "agreement",
  RiskAgreement = "risk-agreement",
  AugustInfo = "august-info",
  CurrenciesList = "currencies-list",
  CallbackAvailableTimes = "callback-available-times",
}

export const baseApi = createApi({
  reducerPath: "api",

  baseQuery: fetchQuery(),
  tagTypes: [
    MutualFundTags.MutualFund,
    CommonApiTypes.Agreement,
    CommonApiTypes.AugustInfo,
    CommonApiTypes.CurrenciesList,
    CommonApiTypes.CallbackAvailableTimes,
    CommonApiTypes.RiskAgreement,
    "Profile",
    "Documents",
    "NewInfoUser",
  ],
  endpoints: (builder) => ({}),
});
